const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        staticLookupName: 'advertisementsController',
        showColorBar: true,
        tabConfigNavKey: 'advertisements',
        showEditByMySelf: true,
    },

    methods: {
        async showProcess(){
            try {
                // get table
                let table
                this.find('templates_crew_advertisements_table', c => table = c)
                if(!table){
                    return this.performMessage({
                        messageDisplay: {
                            message: 'advertisements.showProcess.noTable'
                        }
                    })
                }

                // get table data
                const context = await this.performAction(table.prepareAction('refreshResources', undefined, undefined, {
                    source: {
                        load: {
                            data: {
                                resourceFilters: {
                                    filters: {
                                        loadProcessablesOnly: true
                                    }
                                }
                            }
                        }
                    }
                }))
                const dataToProcess = (((((context || {}).action || {}).source || {}).load || {})._response || {}).dataToProcess || []
                if(utils.collectionSize(dataToProcess) < 1){
                    return this.performMessage({
                        messageDisplay: {
                            message: 'advertisements.showProcess.noData'
                        }
                    })
                }

                // wanna start?
                const decisionContext = await this.performDecision(
                    'confirm',
                    {
                        component:      this,
                        title:          storage.__('advertisements.showProcess.intro.title'),
                        message:        storage.__('advertisements.showProcess.intro.message', { nrOfElements: utils.collectionSize(dataToProcess) }),
                        showLineFeeds:  true,
                    }
                ) || {}
                const decision = decisionContext.decision || {}
                if(decision.type !== 'yes'){
                    return;
                }

                // process piece by piece
                for(const element of Object.values(dataToProcess || [])){
                    if(element.statusDataHash){
                        const onDecisionPromise = utils.promise.newCustom(this)
                        await this.showEdit('advertisements', element.statusDataHash, { attributes: element }, { onDecisionPromise }, {
                            source: {
                                load: {
                                    componentData: {
                                        config: {
                                            transition: {
                                                direction: 'N-S'
                                            }
                                        }
                                    }
                                }
                            }
                        })
                        const {
                            decisionType,
                            decisionComponent,
                            decisionOptions,
                        } = await onDecisionPromise
                        const { status } = decisionOptions || {}

                        const statusPositive = status && status !== 'revoked'
                        const submitDone = decisionType === 'submit'
                        let direction = 'N-E'

                        if(submitDone){
                            if(!statusPositive){
                                direction = 'N-W'
                            }
                        } else {
                            direction = 'S-N'
                        }

                        await decisionComponent.hide(false, { direction })
                        if(!submitDone){
                            break;
                        }
                    }
                }
            } catch (error) {
                console.error(error)
            }
        }
    }
}